/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Produced by tooling/scripts/generate-tokens.mjs from the vendored
 * design system at v3.0.0-rc.1 (2ef3ef5a).
 *
 * These are the DESIGN SYSTEM's values. They are normative and this file
 * is a build artefact — editing it is a fork of the design system that
 * nobody labelled as one (D32).
 *
 * A value the PLATFORM needs and the system does not have goes in a
 * hand-authored file under packages/ui/src/theme/tokens/, carries a
 * D-number, and is handed back to the system project afterwards (D62).
 *
 * Regenerate: `pnpm tokens:generate`.
 */

export const DESIGN_SYSTEM_VERSION = "v3.0.0-rc.1";
export const DESIGN_SYSTEM_COMMIT = "2ef3ef5a66124794498df413c71f8e33a69e7eda";

/** Every token in the system's `:root`, with `var()` resolved. */
export const aerios = {
  ink900: "#1A1A1A",
  ink800: "#1F2022",
  ink700: "#26282A",
  line600: "#2E3134",
  line500: "#3B4044",
  grey600: "#6E7A80",
  grey500: "#88959B",
  grey300: "#A7B2B7",
  white50: "#EEF2F1",
  aqua400: "#3FD9C7",
  aqua500: "#14A896",
  aqua600: "#14A896",
  aqua700: "#0A6F66",
  aqua300: "#7FE8DB",
  brandAqua: "#00FFE7",
  brandViolet: "#784AF5",
  brandGradient: "linear-gradient(90deg, #00FFE7, #784AF5)",
  wordmarkGrey: "#4D4D4D",
  light50: "#F4F6F5",
  lightPanel: "#EAEEED",
  lightHeading: "#07090B",
  lightBody: "#5A6468",
  lightBorder: "#D3DAD9",
  lightAccent: "#0A6C6F",
  statusNeutral: "#88959B",
  statusInfo: "#7CC0F7",
  statusSuccess: "#5FCB95",
  statusAttention: "#E5A93C",
  statusCritical: "#F0655C",
  statusFillAlpha: "0.18",
  statusKeylineAlpha: "0.55",
  statusLabel: "#EEF2F1",
  attention: "#E5A93C",
  critical: "#F0655C",
  fontSans: "Archivo, Helvetica, Arial, sans-serif",
  fontMono: "'IBM Plex Mono', ui-monospace, monospace",
  display1Size: "clamp(40px, 5.2vw, 60px)",
  display1Lh: "1.02",
  display1Ls: "-0.032em",
  display1Wt: "600",
  display2Size: "clamp(32px, 4vw, 44px)",
  display2Lh: "1.08",
  display2Ls: "-0.028em",
  display2Wt: "600",
  heading1Size: "32px",
  heading1Lh: "1.25",
  heading1Ls: "-0.022em",
  heading1Wt: "600",
  heading2Size: "24px",
  heading2Lh: "1.33",
  heading2Ls: "-0.018em",
  heading2Wt: "600",
  heading3Size: "19px",
  heading3Lh: "1.47",
  heading3Ls: "-0.01em",
  heading3Wt: "600",
  bodyLeadSize: "20px",
  bodyLeadLh: "1.5",
  bodyLeadMeasure: "40em",
  bodySize: "16.5px",
  bodyLh: "1.62",
  bodyMeasure: "38em",
  bodySmallSize: "14.5px",
  bodySmallLh: "1.6",
  labelSize: "11px",
  labelLs: "0.14em",
  metricSize: "40px",
  metricLh: "1.1",
  metricWt: "500",
  space1: "4px",
  space2: "8px",
  space3: "12px",
  space4: "16px",
  space5: "24px",
  space6: "32px",
  space7: "48px",
  space8: "64px",
  space9: "96px",
  space10: "128px",
  space11: "160px",
  space12: "224px",
  space13: "288px",
  pageMax: "1440px",
  contentMax: "1280px",
  gutterSm: "16px",
  marginSm: "20px",
  colsSm: "4",
  gutterMd: "24px",
  marginMd: "40px",
  colsMd: "6",
  gutterLg: "24px",
  marginLg: "80px",
  colsLg: "12",
  bpSm: "320px",
  bpMd: "768px",
  bpLg: "1120px",
  bpWide: "1600px",
  pageMaxWide: "1920px",
  marginWide: "clamp(56px, 4.2vw, 112px)",
  display1WideSize: "clamp(48px, 3vw, 58px)",
  displayMeasure: "12em",
  leadMeasure: "26em",
  figureSizeLg: "clamp(36px, 3vw, 56px)",
  figureSizeWide: "clamp(40px, 3.4vw, 68px)",
  radiusControl: "12px",
  radiusMedia: "12px",
  radiusCard: "16px",
  radiusPill: "999px",
  cornerAccent: "16px 16px 16px 0",
  elevHairline: "1px solid #2E3134",
  elevLift: "#1F2022",
  elevOverlay: "0 16px 48px rgba(0,0,0,0.6)",
  ease: "cubic-bezier(.2, 0, 0, 1)",
  durFast: "120ms",
  durBase: "200ms",
  durSlow: "320ms",
  focusRing: "2px solid #3FD9C7",
  focusOffset: "2px",
  targetMin: "24px",
  controlH: "44px",
  controlFont: "16.5px",
  controlPx: "24px",
  controlGap: "12px",
  fieldLabelGap: "8px",
  groupGap: "24px",
  controlInlineH: "24px",
  controlInlineFont: "12px",
  controlInlinePx: "8px",
} as const;

/** The six values `[data-density="compact"]` overrides (D77). Everything else is inherited. */
export const aeriosCompact = {
  controlH: "32px",
  controlFont: "13px",
  controlPx: "10px",
  controlGap: "8px",
  fieldLabelGap: "0px",
  groupGap: "24px",
} as const;

/** The px-valued tokens as numbers, for the many MUI props that want one. */
export const aeriosPx = {
  heading1Size: 32,
  heading2Size: 24,
  heading3Size: 19,
  bodyLeadSize: 20,
  bodySize: 16.5,
  bodySmallSize: 14.5,
  labelSize: 11,
  metricSize: 40,
  space1: 4,
  space2: 8,
  space3: 12,
  space4: 16,
  space5: 24,
  space6: 32,
  space7: 48,
  space8: 64,
  space9: 96,
  space10: 128,
  space11: 160,
  space12: 224,
  space13: 288,
  pageMax: 1440,
  contentMax: 1280,
  gutterSm: 16,
  marginSm: 20,
  gutterMd: 24,
  marginMd: 40,
  gutterLg: 24,
  marginLg: 80,
  bpSm: 320,
  bpMd: 768,
  bpLg: 1120,
  bpWide: 1600,
  pageMaxWide: 1920,
  radiusControl: 12,
  radiusMedia: 12,
  radiusCard: 16,
  radiusPill: 999,
  focusOffset: 2,
  targetMin: 24,
  controlH: 44,
  controlFont: 16.5,
  controlPx: 24,
  controlGap: 12,
  fieldLabelGap: 8,
  groupGap: 24,
  controlInlineH: 24,
  controlInlineFont: 12,
  controlInlinePx: 8,
} as const;

/** camelCase key -> the CSS custom property, for surfaces that want the cascade. */
export const aeriosVar = {
  ink900: "var(--ink-900)",
  ink800: "var(--ink-800)",
  ink700: "var(--ink-700)",
  line600: "var(--line-600)",
  line500: "var(--line-500)",
  grey600: "var(--grey-600)",
  grey500: "var(--grey-500)",
  grey300: "var(--grey-300)",
  white50: "var(--white-50)",
  aqua400: "var(--aqua-400)",
  aqua500: "var(--aqua-500)",
  aqua600: "var(--aqua-600)",
  aqua700: "var(--aqua-700)",
  aqua300: "var(--aqua-300)",
  brandAqua: "var(--brand-aqua)",
  brandViolet: "var(--brand-violet)",
  brandGradient: "var(--brand-gradient)",
  wordmarkGrey: "var(--wordmark-grey)",
  light50: "var(--light-50)",
  lightPanel: "var(--light-panel)",
  lightHeading: "var(--light-heading)",
  lightBody: "var(--light-body)",
  lightBorder: "var(--light-border)",
  lightAccent: "var(--light-accent)",
  statusNeutral: "var(--status-neutral)",
  statusInfo: "var(--status-info)",
  statusSuccess: "var(--status-success)",
  statusAttention: "var(--status-attention)",
  statusCritical: "var(--status-critical)",
  statusFillAlpha: "var(--status-fill-alpha)",
  statusKeylineAlpha: "var(--status-keyline-alpha)",
  statusLabel: "var(--status-label)",
  attention: "var(--attention)",
  critical: "var(--critical)",
  fontSans: "var(--font-sans)",
  fontMono: "var(--font-mono)",
  display1Size: "var(--display-1-size)",
  display1Lh: "var(--display-1-lh)",
  display1Ls: "var(--display-1-ls)",
  display1Wt: "var(--display-1-wt)",
  display2Size: "var(--display-2-size)",
  display2Lh: "var(--display-2-lh)",
  display2Ls: "var(--display-2-ls)",
  display2Wt: "var(--display-2-wt)",
  heading1Size: "var(--heading-1-size)",
  heading1Lh: "var(--heading-1-lh)",
  heading1Ls: "var(--heading-1-ls)",
  heading1Wt: "var(--heading-1-wt)",
  heading2Size: "var(--heading-2-size)",
  heading2Lh: "var(--heading-2-lh)",
  heading2Ls: "var(--heading-2-ls)",
  heading2Wt: "var(--heading-2-wt)",
  heading3Size: "var(--heading-3-size)",
  heading3Lh: "var(--heading-3-lh)",
  heading3Ls: "var(--heading-3-ls)",
  heading3Wt: "var(--heading-3-wt)",
  bodyLeadSize: "var(--body-lead-size)",
  bodyLeadLh: "var(--body-lead-lh)",
  bodyLeadMeasure: "var(--body-lead-measure)",
  bodySize: "var(--body-size)",
  bodyLh: "var(--body-lh)",
  bodyMeasure: "var(--body-measure)",
  bodySmallSize: "var(--body-small-size)",
  bodySmallLh: "var(--body-small-lh)",
  labelSize: "var(--label-size)",
  labelLs: "var(--label-ls)",
  metricSize: "var(--metric-size)",
  metricLh: "var(--metric-lh)",
  metricWt: "var(--metric-wt)",
  space1: "var(--space-1)",
  space2: "var(--space-2)",
  space3: "var(--space-3)",
  space4: "var(--space-4)",
  space5: "var(--space-5)",
  space6: "var(--space-6)",
  space7: "var(--space-7)",
  space8: "var(--space-8)",
  space9: "var(--space-9)",
  space10: "var(--space-10)",
  space11: "var(--space-11)",
  space12: "var(--space-12)",
  space13: "var(--space-13)",
  pageMax: "var(--page-max)",
  contentMax: "var(--content-max)",
  gutterSm: "var(--gutter-sm)",
  marginSm: "var(--margin-sm)",
  colsSm: "var(--cols-sm)",
  gutterMd: "var(--gutter-md)",
  marginMd: "var(--margin-md)",
  colsMd: "var(--cols-md)",
  gutterLg: "var(--gutter-lg)",
  marginLg: "var(--margin-lg)",
  colsLg: "var(--cols-lg)",
  bpSm: "var(--bp-sm)",
  bpMd: "var(--bp-md)",
  bpLg: "var(--bp-lg)",
  bpWide: "var(--bp-wide)",
  pageMaxWide: "var(--page-max-wide)",
  marginWide: "var(--margin-wide)",
  display1WideSize: "var(--display-1-wide-size)",
  displayMeasure: "var(--display-measure)",
  leadMeasure: "var(--lead-measure)",
  figureSizeLg: "var(--figure-size-lg)",
  figureSizeWide: "var(--figure-size-wide)",
  radiusControl: "var(--radius-control)",
  radiusMedia: "var(--radius-media)",
  radiusCard: "var(--radius-card)",
  radiusPill: "var(--radius-pill)",
  cornerAccent: "var(--corner-accent)",
  elevHairline: "var(--elev-hairline)",
  elevLift: "var(--elev-lift)",
  elevOverlay: "var(--elev-overlay)",
  ease: "var(--ease)",
  durFast: "var(--dur-fast)",
  durBase: "var(--dur-base)",
  durSlow: "var(--dur-slow)",
  focusRing: "var(--focus-ring)",
  focusOffset: "var(--focus-offset)",
  targetMin: "var(--target-min)",
  controlH: "var(--control-h)",
  controlFont: "var(--control-font)",
  controlPx: "var(--control-px)",
  controlGap: "var(--control-gap)",
  fieldLabelGap: "var(--field-label-gap)",
  groupGap: "var(--group-gap)",
  controlInlineH: "var(--control-inline-h)",
  controlInlineFont: "var(--control-inline-font)",
  controlInlinePx: "var(--control-inline-px)",
} as const;

export type AeriosToken = keyof typeof aerios;
